import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Statusbar } from '@/types/statusbar'

export function updateStatusbar(
  body: Statusbar
): Promise<AxiosResponse<Statusbar>> {
  return instance.patch(`/notification/${body.uuid}`, body)
}
